import * as React from "react";
import { Box, Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MarcatureOperatore from "./MarcatureOperatore";
import SectionOperatore from "./SectionOperatore"; 

const Operatore = () => {

  const params = useParams(); 
  const navigate = useNavigate(); 

  if(!params.id) { navigate("/"); return null; }

  return (
    <Box>
      <Button onClick={() => {

        navigate(-1); 

      }} variant="contained" sx={{mb:2}} startIcon={<ArrowBackIcon />}>Torna indietro</Button>
      <SectionOperatore idoperatorecantiere={params.id} />
      <MarcatureOperatore idoperatorecantiere={params.id} />
    </Box>
  );
};

export default Operatore;
